import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'
import { AttachmentsState, AttachmentResource } from './attachments.types'

const mutations: MutationTree<AttachmentsState> = {
  SET_ATTACHMENT (state, attachment: AttachmentResource) {
    Vue.set(state.data, attachment.id, attachment)
  }
}

export default mutations

